export default {
  'name': '@okta/okta-angular',
  'version': '6.5.1',
  'authJSMinSupportedVersion': '5.3.1'
};
